/**
 * @author Johann Kowalski (traal-devel) <devel@traal.ch>
 */


import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TvfAuthService } from 'src/app/service/tvf-auth.service';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {


  /* member variables */


  /* constructors */
  constructor(
    private tvfAuthService: TvfAuthService,
    private router: Router
  ) { }


  /* methods */
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          if (!this.tvfAuthService.checkAutoLogin()) {
            this.router.navigate(['/epg/grid']);
          } else {
            this.tvfAuthService.logout();
            this.router.navigate(['/login']);
          }
        }
        return throwError(err);
      })
    ) as Observable<HttpEvent<any>>;
  }
}
